export const createStorageService = <T>(key: string, storage: Storage) => ({
  get() {
    try {
      const raw = storage.getItem(key);
      return raw === null ? null : JSON.parse(raw);
    } catch {
      return null;
    }
  },
  set(value: T) {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch {
      return null;
    }
  },
  remove() {
    storage.removeItem(key);
  },
});
